




































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import Decisions from '@/store/modules/Decisions';
import { getModule } from 'vuex-module-decorators';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import { NotificationEventBus } from '@/EventBus';
import _ from 'lodash';
import ListInputDialog from '@/components/forms/ListInputDialog.vue';
import ChoiceInputDialog from '@/components/choice-input/ChoiceInputDialog.vue'
import Choices, { Choice } from '@/store/modules/Choices';
import { Decision } from '@/api/model/Decision';
import ChoiceFileImporter from "@/views/ChoiceImport/ChoiceFileImporter.vue"

const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);
const WorkspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: {
        ListInputDialog,
        ChoiceInputDialog,
        ChoiceFileImporter
    },
})
export default class ChoiceCreatorButton extends Vue {
    @Prop({ default: 'NEW', type: String })
    btnText!: string;

    @Prop({ default: false, type: Boolean })
    menuRight!: boolean

    @Prop({ default: false, type: Boolean })
    menuBottom!: boolean

    @Prop({ default: false, type: Boolean })
    offsetX!: boolean
    @Prop({ default: false, type: Boolean })
    offsetY!: boolean

    @Prop({ default: false, type: Boolean })
    menuLeft!: boolean

    @Prop({ default:false, type:Boolean})
    loading!: boolean;

    private menuShow = false;
    private refreshing = false;
    private addToList = false;


    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }
    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get selectedDecision(): Decision {
        return decisionsModule.selectedDecision;
    }

   get activeChoiceList(): string[] {
        return WorkspaceOptionsModule.activeChoiceLists;
    }
    // Create Viewpoint(s) from a List
  
    private async createChoicesFromList(payload: any) {
        let list = payload.names;
        let addToList = _.clone(payload.addToList)
        if (list.length) {
            let choices = list.filter(l => l)
                .map(name => {
                    return {
                        name: name
                    } as Choice
                })
            this.refreshing = true;
            let newChoices = await choicesModule.createChoices(choices)
            if(addToList && newChoices) {
                for(let choice of Object.values(newChoices)) {
                    decisionsModule.addChoiceToActiveLists(choice.id)

                }
            }
            choicesModule.fetchChoices()
            this.refreshing = false;
        }
    }


    private async refresh() {
        this.refreshing = true;
        await choicesModule.fetchChoices();
        this.refreshing = false;   
    }
}
